import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class GclidService {

  private readonly storageKey = 'gclid';

  constructor() {
    this.checkAndStoreGclid();
  }

  private checkAndStoreGclid(): void {
    const params = new URLSearchParams(window.location.search);
    const gclid = params.get('gclid');

    if (gclid) {
      localStorage.setItem(this.storageKey, gclid);
    }
  }

  getGclid(): string | null {
    return localStorage.getItem(this.storageKey);
  }
}
